import * as React from 'react';
import { useLayoutEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import InspectionPointPage from './pages/safetyinspections/[activityId]/inspections/[facilityInspectionId]/InspectionPointPage';
import LoginPage from './pages/login/[siteId]/LoginPage';
import PrivacyPolicyPage from './pages/privacy/PrivacyPolicyPage';
import { StartSurveyAnswerPage } from './pages/surveys/[surveyId_siteId]/StartSurveyAnswerPage';
import { SupportPage } from './pages/support/SupportPage';
import { SurveyAnswerPage } from './pages/surveys/[surveyId_siteId]/answers/[answerId]/SurveyAnswerPage';
import { SurveyReportPublicPage } from './pages/surveys/publicreport/[linkId_siteId]/SurveyReportPublicPage';
import { UserLandingPage } from './pages/user/overview/UserLandingPage';
import WorkgroupMeetingListingPage from './pages/workgroupmeetings/WorkgroupMeetingListingPage';
import WorkplaceAssessmentListingPage from './pages/workplaceassessments/WorkplaceAssessmentListingPage';
import WorkplaceAssessmentPage from './pages/workplaceassessments/[activityId]/WorkplaceAssessmentPage';
import { ActionPlanListPage } from './pages/actionplans/ActionPlanListPage';
import ActionPlanPage from './pages/actionplans/ActionPlanPage';
import ActionPlanPublicPage from './pages/actionplans/ActionPlanPublicPage';
import { AmorgAdminEditTemplate } from './pages/amorgAdmin/AmorgAdminEditTemplate';
import AmorgAdminGlobalTemplates from './pages/amorgAdmin/AmorgAdminGlobalTemplates';
import { AmorgAdminImportTemplate } from './pages/amorgAdmin/AmorgAdminImportTemplate';
import { AmorgAdminLogin } from './pages/amorgAdmin/AmorgAdminLogin';
import { AmorgAdminLogout } from './pages/amorgAdmin/AmorgAdminLogout';
import { AmorgAdminProfile } from './pages/amorgAdmin/AmorgAdminProfile';
import { AmorgAdminSite } from './pages/amorgAdmin/sites/AmorgAdminSite';
import { AmorgAdminImportUsers } from './pages/amorgAdmin/AmorgAdminImportUsers';
import AmorgAdminSiteLogin from './pages/amorgAdmin/AmorgAdminLanding';
import AmorgAdminSites from './pages/amorgAdmin/AmorgAdminSites';
import AmorgAdminOrganizations from './pages/amorgAdmin/AmorgAdminOrganizations';
import AmorgAdminUsers from './pages/amorgAdmin/AmorgAdminUsers';
import ArticlesConfiguration from './pages/amorgAdmin/articles/ArticlesConfiguration';
import ArticlesFollowUp from './pages/amorgAdmin/articles/ArticlesFollowUp';
import ArticlesList from './pages/amorgAdmin/articles/ArticlesList';
import ArticlesSubscriber from './pages/amorgAdmin/articles/ArticlesSubscriber';
import ArticlesSubscriberList from './pages/amorgAdmin/articles/ArticlesSubscriberList';
import ArticlesView from './pages/amorgAdmin/articles/ArticlesView';
import ArticlesRetsinfoOverviewPage from './pages/amorgAdmin/articles/retsinfo/RetsinfoOverviewPage';
import { ArticlesLightPage } from './pages/articles/ArticlesLightPage';
import { ArticlesOverviewPage } from './pages/articles/ArticlesOverviewPage';
import { ArticlePage } from './pages/articles/[articleId]/ArticlePage';
import { InternalArticleListPage } from './pages/articles/internal/InternalArticleListPage';
import { InternalArticlePage } from './pages/articles/internal/[internalArticleId]/InternalArticlePage';
import { ArticleListPage } from './pages/articles/list/ArticleListPage';
import { PublicArticlePage } from './pages/articles/public/[articleId]/PublicArticlePage';
import ConfirmCreateUserPage from './pages/confirm/ConfirmCreateUserPage';
import ConfirmNewEmailPage from './pages/confirm/ConfirmNewEmailPage';
import ConfirmPasswordResetPage from './pages/confirm/ConfirmPasswordResetPage';
import { CustomFormPage } from './pages/customForms/[parm]/CustomFormPage';
import { CustomFormAnswerPage } from './pages/customForms/[parm]/answers/[parm]/CustomFormAnswerPage';
import { CustomFormReportPage } from './pages/customForms/[parm]/report/CustomFormReportPage';
import { CustomFormStartAnswerPublicPage } from './pages/customForms/public/CustomFormStartAnswerPublicPage';
import { CustomFormSubmitAnswerPublicPage } from './pages/customForms/public/CustomFormSubmitAnswerPublicPage';
import { DesignSystemPage } from './pages/dev/DesignSystemPage';
import { DummyPage } from './pages/dev/DummyPage';
import { DocumentArchiveOverviewPage } from './pages/documentArchive/DocumentArchiveOverviewPage';
import { ErgonomicsPage } from './pages/ergonomy/ErgonomicsPage';
import ErrorPage from './pages/error/ErrorPage';
import InsufficientPermissionPage from './pages/error/InsufficientPermissionPage';
import { ExternalLinksOverviewPage } from './pages/externallinks/ExternalLinksOverviewPage';
import { LearningModuleListPage } from './pages/learning/LearningModuleListPage';
import { LearningModulePage } from './pages/learning/[parms]/LearningModulePage';
import { NotificationsPage } from './pages/notifications/NotificationsPage';
import { OrganizationPage } from './pages/organization/OrganizationPage';
import ProfilePage from './pages/profile/ProfilePage';
import { LearningModuleListPublicPage } from './pages/public/learning/LearningModuleListPublicPage';
import { LearningModulePublicPage } from './pages/public/learning/[parms]/LearningModulePublicPage';
import RequestCreateUserPage from './pages/request/RequestCreateUserPage';
import RequestPasswordResetPage from './pages/request/RequestPasswordResetPage';
import RequestPasswordSetupPage from './pages/request/RequestPasswordSetupPage';
import UserListingPage from './pages/users/UserListingPage';
import UserPage from './pages/users/[userId]/UserPage';
import { applicationEndpoints } from './amorg-common/applicationEndpoints';
import { IncidentListPage } from './pages/incidents/IncidentListPage';
import { IncidentPage } from './pages/incidents/IncidentPage';
import { IncidentReporterPublicPage } from './pages/incidents/public/[siteId]/[id]/IncidentReporterPublicPage';
import { PortalHomePage } from './pages/portal/PortalHomePage';
import { PortalLogoutPage } from './pages/portal/PortalLogoutPage';
import { PortalAccessKeyPage } from './pages/portal/access-key/[siteId]/[accessKey]/PortalAccessKeyPage';
import { PortalFileListPage } from './pages/portal/files/PortalFileListPage';
import { PortalIncidentPage } from './pages/portal/incidents/[type]/PortalIncidentPage';
import { PortalLinkListPage } from './pages/portal/links/PortalLinkListPage';
import { PortalLoginPage } from './pages/portal/login/[siteId]/PortalLoginPage';
import { PortalLoginConfirmPage } from './pages/portal/login/[siteId]/confirm/PortalLoginConfirmPage';
import { PortalLaunchPage } from './pages/portal/launch/[siteId]/PortalLaunchPage';
import { PortalOrganizationPage } from './pages/portal/organization/PortalOrganizationPage';
import { PortalReportListPage } from './pages/portal/reports/PortalReportListPage';
import { SettingsPage } from './pages/settings/SettingsPage';
import { SurvyQuestionPage } from './pages/survy/SurvyQuestionPage';
import { SurvyStartPage } from './pages/survy/SurvyStartPage';
import { SurvyThanksPage } from './pages/survy/SurvyThanksPage';
import { PortalSurveyReportPage } from './pages/portal/reports/PortalSurveyReportPage';
import AnnualWorkgroupStatusListingPage from './pages/annualworkgroupstatus/AnnualWorkgroupStatusListingPage';
import AnnualWorkgroupStatusPage from './pages/annualworkgroupstatus/[activityId]/AnnualWorkgroupStatusPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import InspectionPointConfigurationPage from './pages/inspectionpoints/InspectionPointConfigurationPage';
import SafetyInspectionListingPage from './pages/safetyinspections/SafetyInspectionListingPage';
import SafetyInspectionPage from './pages/safetyinspections/[activityId]/SafetyInspectionPage';
import LocationListingPage from './pages/locations/LocationListingPage';
import LogoutPage from './pages/logout/LogoutPage';
import ContactSupportPage from './pages/support/contact/ContactSupportPage';
import WorkgroupMeetingPage from './pages/workgroupmeetings/[activityId]/WorkgroupMeetingPage';
import AmorgAdminLanding from './pages/amorgAdmin/AmorgAdminLanding';
import { AmorgAdminOrganizationInfo } from './pages/amorgAdmin/organizations/AmorgAdminOrganizationInfo';
import { AmorgAdminOrganizationDeals } from './pages/amorgAdmin/organizations/AmorgAdminOrganizationDeals';
import { AmorgAdminOrganizationNotes } from './pages/amorgAdmin/organizations/AmorgAdminOrganizationNotes';



const ScrollToTop = (props) =>
{
    const location = useLocation();
    // using useLayoutEffect to set the title with fallback to "Amorg"
    useLayoutEffect(() =>
    {
        window.scrollTo(0, 0);
        document.title = 'Amorg';
    }, [location]);

    return <>{props.children}</>;
};

const urls = applicationEndpoints;

export function AmorgRoutes (): JSX.Element
{

    return (
        <ScrollToTop>
            <Routes>

                <Route path="/login/:siteId?" element={<LoginPage />} />

                <Route path="/logout" element={<LogoutPage />} />

                <Route path="/profile" element={<ProfilePage />} />

                <Route path="/users/:userId" element={<UserPage />} />

                <Route path="/users" element={<UserListingPage />} />


                <Route path={urls.organization} element={<OrganizationPage />} />

                <Route path="/actionplans/public/:linkIdSiteId" element={<ActionPlanPublicPage />} />

                <Route path="/actionplans/:actionPlanId" element={<ActionPlanPage />} />

                <Route path="/actionplans" element={<ActionPlanListPage />} />

                <Route path={urls.annualworkgroupstatus_activityId} element={<AnnualWorkgroupStatusPage />} />

                <Route path={urls.annualworkgroupstatus} element={<AnnualWorkgroupStatusListingPage />} />

                <Route path="/workgroupmeetings/:activityId" element={<WorkgroupMeetingPage />} />

                <Route path="/workgroupmeetings" element={<WorkgroupMeetingListingPage />} />

                <Route path={urls.workplacesassessments_activityId} element={<WorkplaceAssessmentPage />} />
                <Route path={urls.workplacesassessments} element={<WorkplaceAssessmentListingPage />} />

                <Route path="/safetyinspections/:activityId/inspections/:facilityInspectionId" element={<InspectionPointPage />} />

                <Route path="/safetyinspections/:activityId" element={<SafetyInspectionPage />} />

                <Route path="/safetyinspections" element={<SafetyInspectionListingPage />} />

                <Route path="/inspectionpoints" element={<InspectionPointConfigurationPage />} />

                <Route path="/locations" element={<LocationListingPage />} />

                <Route path="/surveys/publicreport/:linkIdSiteId" element={<SurveyReportPublicPage />} />

                <Route path="/surveys/:surveyIdSiteId/answers/:answerId" element={<SurveyAnswerPage />} />
                <Route path="/surveys/:surveyIdSiteId" element={<StartSurveyAnswerPage />} />

                <Route path="/confirm/resetpassword/:siteId/:userId/:requestId" element={<ConfirmPasswordResetPage />} />
                <Route path="/confirm/setuppassword/:siteId/:userId/:requestId" element={<ConfirmPasswordResetPage />} />
                <Route path="/request/resetpassword" element={<RequestPasswordResetPage />} />
                <Route path="/request/setuppassword" element={<RequestPasswordSetupPage />} />
                <Route path="/confirm/newemail/:siteId/:userId/:requestId" element={<ConfirmNewEmailPage />} />
                <Route path="/confirm/createuser/:siteId/:userId/:requestId" element={<ConfirmCreateUserPage />} />
                <Route path="/request/createuser" element={<RequestCreateUserPage />} />

                <Route path="/error" element={<ErrorPage />} />
                <Route path="/insufficientpermission" element={<InsufficientPermissionPage />} />

                <Route path="/dev/designsystem" element={<DesignSystemPage />} />

                <Route path="/user/overview" element={<UserLandingPage />} />

                <Route path="/externallinks" element={<ExternalLinksOverviewPage />} />

                <Route path="/documentarchive" element={<DocumentArchiveOverviewPage />} />

                <Route path="/notifications" element={<NotificationsPage />} />

                <Route path={urls.dashboard} element={<DashboardPage />} />

                <Route path={'/amorgy/login'} element={<AmorgAdminLogin />} />

                <Route path={'/amorgy/logout'} element={<AmorgAdminLogout />} />

                <Route path={'/amorgy/globaltemplates'} element={<AmorgAdminGlobalTemplates />} />

                <Route path={'/amorgy/importtemplate'} element={<AmorgAdminImportTemplate />} />

                <Route path={'/amorgy/edittemplate/:templateId'} element={<AmorgAdminEditTemplate />} />

                <Route path={'/amorgy/users'} element={<AmorgAdminUsers />} />

                <Route path={'/amorgy/profile'} element={<AmorgAdminProfile />} />

                <Route path={'/amorgy/sites/:siteId/import-users'} element={<AmorgAdminImportUsers />} />
                <Route path={'/amorgy/sites/:siteId'} element={<AmorgAdminSite />} />
                <Route path={'/amorgy/sites'} element={<AmorgAdminSites />} />

                <Route path={'/amorgy/organizations/:organizationId/companyInfo'} element={<AmorgAdminOrganizationInfo />} />
                <Route path={'/amorgy/organizations/:organizationId/companyInfo'} element={<AmorgAdminOrganizationInfo />} />
                <Route path={'/amorgy/organizations/:organizationId/deals'} element={<AmorgAdminOrganizationDeals />} />
                <Route path={'/amorgy/organizations/:organizationId/notes'} element={<AmorgAdminOrganizationNotes />} />
                <Route path={'/amorgy/organizations'} element={<AmorgAdminOrganizations />} />


                <Route path={'/amorgy/articles/subscribers/:subscriberId'} element={<ArticlesSubscriber />} />
                <Route path={'/amorgy/articles/subscribers'} element={<ArticlesSubscriberList />} />
                <Route path={'/amorgy/articles/configuration'} element={<ArticlesConfiguration />} />
                <Route path={'/amorgy/articles/followup'} element={<ArticlesFollowUp />} />
                <Route path={'/amorgy/articles/retsinfo'} element={<ArticlesRetsinfoOverviewPage />} />
                <Route path={'/amorgy/articles/:id'} element={<ArticlesView />} />
                <Route path={'/amorgy/articles'} element={<ArticlesList />} />

                <Route path={'/amorgy/overview'} element={<AmorgAdminLanding />} />

                <Route path={'/amorgy'} element={<AmorgAdminSiteLogin />} />


                <Route path={'/support/contact'} element={<ContactSupportPage />} />

                <Route path={'/support'} element={<SupportPage />} />

                <Route path={'/privacy'} element={<PrivacyPolicyPage />} />

                <Route path="/customforms/public/:keySiteId" element={<CustomFormStartAnswerPublicPage />} />

                <Route path="/customforms/public/:siteId/:answerId" element={<CustomFormSubmitAnswerPublicPage />} />

                <Route path="/customforms/:formId/answers/:answerId" element={<CustomFormAnswerPage />} />

                <Route path="/customforms/:formId/report" element={<CustomFormReportPage />} />

                <Route path="/customforms/:activityId" element={<CustomFormPage />} />

                <Route path="/ergonomics" element={<ErgonomicsPage />} />

                <Route path="/articles/internal/:internalArticleId" element={<InternalArticlePage />} />

                <Route path="/articles/summary" element={<ArticlesLightPage />} />

                <Route path="/articles/internal" element={<InternalArticleListPage />} />

                <Route path="/articles/list" element={<ArticleListPage />} />

                <Route path={urls.public_article_siteId_articleId} element={<PublicArticlePage />} />

                <Route path="/articles/:articleId" element={<ArticlePage />} />

                <Route path="/articles" element={<ArticlesOverviewPage />} />

                <Route path={urls.settings} element={<SettingsPage />} />

                {/*----------------------------------- THESE SHOULD BE REMOVED ONCE NO LONGER NEEDED BEGIN ------------------------------------------ */}
                <Route path="/learning/public/:moduleId" element={<LearningModulePublicPage />} />

                <Route path="/learning/public" element={<LearningModuleListPublicPage />} />
                {/*----------------------------------- THESE SHOULD BE REMOVED ONCE NO LONGER NEEDED END------------------------------------------ */}



                <Route path="/learning/:moduleId" element={<LearningModulePage />} />

                <Route path="/learning" element={<LearningModuleListPage />} />

                <Route path={urls.incidents_id} element={<IncidentPage />} />

                <Route path={urls.incidents} element={<IncidentListPage />} />

                <Route path={urls.public_incidents_siteId_id} element={<IncidentReporterPublicPage />} />

                <Route path={urls.public_learning_moduleId} element={<LearningModulePublicPage />} />

                <Route path={urls.public_learning} element={<LearningModuleListPublicPage />} />


                <Route path="/dev/dummy" element={<DummyPage />} />

                <Route path={urls.portal_access_key_siteId_accessKey} element={<PortalAccessKeyPage />} />

                <Route path={urls.portal_login_siteId_confirm_email_requestId} element={<PortalLoginConfirmPage />} />

                <Route path={urls.portal_launch_siteId} element={<PortalLaunchPage />} />

                <Route path={urls.portal_login_siteId} element={<PortalLoginPage />} />

                <Route path={urls.portal_login} element={<PortalLoginPage />} />

                <Route path={urls.portal_logout} element={<PortalLogoutPage />} />

                <Route path={urls.portal_organization} element={<PortalOrganizationPage />} />

                <Route path={urls.portal_files} element={<PortalFileListPage />} />

                <Route path={urls.portal_links} element={<PortalLinkListPage />} />

                <Route path={urls.portal_survey_report_portalResourceId} element={<PortalSurveyReportPage />} />

                <Route path={urls.portal_survey_reports} element={<PortalReportListPage />} />

                <Route path={urls.portal_incidents_type} element={<PortalIncidentPage />} />

                <Route path={urls.portal} element={<PortalHomePage />} />

                {/* ---------------- SIMPLE SURVEY ROUTES ------------------ */}

                <Route path={urls.survy_key_surveyId_responseId_questions_questionIndex} element={<SurvyQuestionPage />} />

                <Route path={urls.survy_key_surveyId_responseId_thanks} element={<SurvyThanksPage />} />

                <Route path={urls.survy_key_surveyId_responseId} element={<SurvyStartPage />} />

                {/* Keep this route last. '/' is very broad and can shadow other routes. */}
                <Route path={urls.root} element={<DashboardPage />} />


            </Routes>
        </ScrollToTop>
    );
}